type RegistryDatasetDisplayRef = { display_name: string };

// registry 원본도 상류 이름도 없는 학습 입력의 표기. 정책 표·세션 목록/상세·평가 결과
// 표/상세가 모두 이 문구 하나를 쓴다.
export const TRAINING_INFRA_ONLY_DATASET_LABEL = "training-infra 전용 Dataset";

/**
 * 학습 입력 하나의 표시 이름. 우선순위는 registry 표시명 > 상류 이름 > training 전용 표기다.
 *
 * 상류 이름은 서버가 이미 거른 값이다. registry 가 상류에 붙인 내부 등록 이름
 * (`reg-ds-<uuid>`)은 null 로 온다. `alba_v3` 처럼 training 에서 직접 만든 데이터셋의
 * 실제 이름만 남는다. 그 데이터셋에는 그 이름이 유일한 정보다. 그래서 숨기지 않는다.
 *
 * 이 함수는 "입력 자체가 없다" 를 판정하지 않는다. 빈 값 표현은 자리마다 다르다(셀은 대시,
 * 캡션은 행을 숨긴다). 호출부가 입력 유무를 먼저 확인한 뒤 이 함수를 호출한다.
 */
export function registryDatasetDisplayLabel(
  ref: RegistryDatasetDisplayRef | null | undefined,
  upstreamLabel?: string | null,
): string {
  if (ref) return ref.display_name;
  return upstreamLabel ?? TRAINING_INFRA_ONLY_DATASET_LABEL;
}
